import { trigger, state, style, animate, transition } from '@angular/animations';

export const loadingFade = trigger('loadingFade', [
	state('hidden', style({ opacity: 0, display: 'none' })),
	state('shown', style({ opacity: 0.7, overflow:'hidden' })),
	transition('shown => hidden', animate('200ms ease-out'))
]);

export const modal = trigger('modal', [
	state('hidden', style({ opacity: 0, display: 'none', top: '-100px', backgroundColor: 'rgba(0,0,0,0)' })),
	state('shown', style({ opacity: 1, display: 'block', top: 0, backgroundColor: 'rgba(0,0,0,0.5)' })),
	transition('* => shown', animate('200ms ease-out')),
	transition('shown => hidden', animate('200ms ease-out'))
]);

export const alert = trigger('alert', [
	state('hidden', style({ opacity: 0, display: 'none' })),
	state('shown', style({ opacity: 1, display: 'block' })),
	transition('* => shown', animate('0ms ease-out')),
	transition('shown => hidden', animate('5000ms ease-in'))
]);

export const subTop = trigger('subTop', [
	state('hidden', style({ opacity: 0, display: 'none', top: '0px' })),
	state('shown', style({ opacity: 1, display: 'block', top: '35px' })),
	transition('* => shown', animate('200ms ease-out')),
	transition('shown => hidden', animate('200ms ease-out'))
]);